export default "__VITE_ASSET__CnkxpmDX__"